
<template>
<v-container fluid style="height:100%; background-color:#222">
  <v-layout xs12 column wrap>
    <v-flex xs12 style="margin-bottom:15px">
      <v-icon style="font-size:24px;color:#8debd2;">fas fa-puzzle-piece</v-icon><span class="pl-2 ml-2" style="font-size:13px; text-transform:uppercase;color:#8debd2">logic</span>
    </v-flex>
      <v-layout row xs21 >
        <v-flex xs2 class="mr-3">
            <v-select dark
              v-model="selectedType"
              label="Type"
              :items="types"
              @input="selectType"
            ></v-select>
        </v-flex>
        <!-- create tab -->
<!--        conditional-->
        <v-flex xs2 v-if="selectedType === 'Conditional'" class="mr-3">
          <v-select
            dark
            v-model="selectedConditionType"
            label="Condition Type"
            :items="conditionTypes"
            @input="selectConditionType"
          >
          </v-select>
        </v-flex>
<!--          Verbal-->
        <v-flex xs2 v-if="selectedConditionType === 'Verbal' && selectedType === 'Conditional'" class="mr-3">
          <v-text-field
            label="# of Users Conditions"
            hints="Anticipated User Responses #"
            v-model.number="numberOfUserNodes.value"
            dark
            :items="numfUserNodes"
            type="number"
            @change="numberOfUserNodesChanged"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 v-if="verbals.length > 0 && selectedConditionType === 'Verbal' && selectedType === 'Conditional'">
            <v-layout column>
              <v-flex xs3 v-for="(num, index) in verbals.length" :key="index">
                  <v-layout row>
                    <v-text-field
                      label="Condition - Verbal"
                      dark
                      v-model="verbals[index].value"
                    >
                    </v-text-field>
                    <v-btn v-if="!checkIfAddedInUserNodeList(verbals[index]) && !checkIfUserExisted(verbals[index])" dark @click="addToLists(verbals[index])">Add</v-btn>
                  </v-layout>
              </v-flex>
            </v-layout>
          <v-btn v-if="userNodeList.length > 0" dark @click="addUser">Submit</v-btn>
        </v-flex>

<!--Touch-->
        <v-flex xs2 v-if="selectedType === 'Touch'" class="mr-3">
          <v-select
            dark
            v-model="selectedTouchType"
            label="Touch Type"
            :items="touchTypes"
            @input="selectTouchType"
          >
          </v-select>
        </v-flex>

        <v-flex xs2 v-if="selectedTouchType === '3D' && selectedType === 'Touch'" class="mr-3">
          <v-text-field
            label="Number of Conditions"
            hints="Anticipated User Responses #"
            v-model.number="numberOfUserNodes.value"
            dark
            :items="numfUserNodes"
            type="number"
            @change="numberOfUserNodesChanged"
          ></v-text-field>
        </v-flex>

        <v-flex xs10 v-if="verbals.length > 0 && selectedTouchType === '3D' && selectedType === 'Touch'" class="mr-3">
          <v-layout column>
            <v-flex xs8 v-for="(num, index) in verbals.length" :key="index">
              <v-layout row>

                <v-flex xs2 v-if="selectedTouchType === '3D' && selectedType === 'Touch'" class="mr-3">
                  <v-select
                    dark
                    v-model="interaction[index]"
                    label="Interaction Type"
                    :items="interactionTypes"
                  ></v-select>
                </v-flex>

                <v-flex xs2 v-if="interaction[index] === 'Swipe' && selectedTouchType === '3D' && selectedType === 'Touch'" class="mr-3">
                  <v-select
                    dark
                    v-model="direction[index]"
                    label="Condition"
                    :items="conditionsOfSwipe"
                  ></v-select>
                </v-flex>

                <v-flex xs2 v-if="interaction[index] === 'Tap' && selectedTouchType === '3D' && selectedType === 'Touch'" class="mr-3">
                  <v-select
                    dark
                    v-model="direction[index]"
                    label="Condition"
                    :items="conditionsOfTap"
                  ></v-select>
                </v-flex>

                <v-flex xs2 v-if="interaction && direction && selectedTouchType === '3D' && selectedType === 'Touch'" class="mr-3">
                  <v-select
                    :items="asset"
                    :item-text="item => item.name"
                    :item-value="item=> item.id"
                    v-model="verbals[index].value"
                    label="3D Assets"
                    chips
                    persistent-hint
                    dark
                  ></v-select>
                </v-flex>

                <v-btn v-if="!checkIfAddedInUserNodeList(verbals[index]) && !checkIfUserExisted(verbals[index])" dark @click="addToLists(verbals[index])">Add</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-btn v-if="userNodeList.length > 0" dark @click="addUser">Submit</v-btn>
        </v-flex>

<!--Touch End-->

<!--          Non-Verbal-->
         <v-flex xs1 v-if="selectedConditionType === 'Non-Verbal' && selectedType === 'Conditional'">
          <v-text-field
            label="# of Conditions"
            v-model.number="numberOfUserNodes.value"
            dark
            :items="numfUserNodes"
            type="number"
            @change="numberOfUserNodesChanged"
          ></v-text-field>
        </v-flex>

        <v-flex xs4 v-if="nonVerbals.length > 0 && selectedConditionType === 'Non-Verbal' && selectedType === 'Conditional'">
          <v-flex v-for="(num, index) in nonVerbals.length" :key="index">
            <v-layout row>
              <v-select class="ma-2" style="margin-right:100px" dark outline v-model="nonVerbals[index].visualItem" :items="visualItems" label="Select" single-line persistent-hint></v-select>
              <v-btn v-if="!checkIfAddedInUserNodeList(nonVerbals[index]) && !checkIfUserExisted(nonVerbals[index])" dark @click="addToLists(nonVerbals[index])">Add</v-btn>
            </v-layout>
          </v-flex>
          <v-btn v-if="userNodeList.length > 0" dark @click="addUser">Submit</v-btn>
        </v-flex>

<!--        Specific-->
        <v-flex class="mr-2" xs2 v-if="selectedType === 'Specific'">
            <v-text-field dark
              label="Number of Scene(s)"
              v-model.number="numberOfSceneNodes.value"
              type="number"
              placeholder="Enter number of Scenes"
              @change="numberOfSceneNodesChanged"
            ></v-text-field>
        </v-flex>
        <v-flex xs6 v-if="selectedType === 'Specific'">
            <v-layout row>
              <v-flex class="mr-2" xs2
              v-for="(probability, i) in probabilities.value" :key="i">
                <v-text-field dark label="Probability"
                  v-model.number="probabilities.value[i]"
                  type="number"
                  @input="probabilityChanged(i)"
                ></v-text-field>
              </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-dialog v-model="presentConfirmation" persistent max-width="350">
            <v-card dark style="background-color:#222" class="pa-2">
              <v-card-title class="headline">{{ confirmationDialogueTitle }}</v-card-title>
              <v-card-text> {{ confirmationDialogueMessage }} </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-flex style="text-align:right">
                  <v-btn round outline text @click="onCancelDialogue">Cancel</v-btn>
                  <v-btn round outline text @click="onConfirmationDialogue">Confirm</v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
  </v-layout>
</v-container>
</template>
<script>
import fuzz from 'wordfuzz'
import uniqid from 'uniqid'
import _ from 'lodash'
import {db} from '../../firebaseDB'

export default {
  props: ['currentNode', 'editor', 'diagramData'],
  data () {
    return {
      numfUserNodes: ['1', '2', '3', '4', '5', '6', '7', '8'],
      numberOfUserNodes: this.readOrAdjustNumberOfUserNodes(),
      numberOfSceneNodes: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'numberOfSceneNodes'),
      probabilities: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'probabilities'),
      defaultChatbotLine: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'defaultChatbotLine'),
      selectedType: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'type').value,
      condition_type: ['Verbal', 'Non-verbal'],
      types: ['Specific', 'Conditional', 'Touch'],
      // 3d touch
      touchTypes: ['2D', '3D'],
      interactionTypes: ['Swipe', 'Tap'],
      conditionsOfSwipe: ['Up', 'Down', 'Left', 'Right'],
      conditionsOfTap: ['Tap', 'Double Tap'],
      direction: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'direction').value || [],
      interaction: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'interaction').value || [],
      selectedTouchType: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'touchType').value || '',
      nextNodes: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'nextID').value || [],
      asset: [],
      // selectedAsset: [],
      selectedConditionType: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'conditionType').value,
      conditionTypes: ['Verbal', 'Non-Verbal'],
      presentConfirmation: false,
      confirmationDialogueTitle: 'Are you Sure?',
      confirmationDialogueMessage: 'This will unlink all of the nodes connected to this Logic Node.',
      verbals: this.fetchItsUserVerbal(),
      nonVerbals: this.fetchItsUserNonVerbal(),
      visualItems: this.editor.userConditionItems.filter(userConditionItem => userConditionItem.section === 'photo').map(item => item.fieldName),
      userNodeList: []
    }
  },
  created () {
    db.ref('assets/asset_data/prop/')
      .once('value')
      .then(snapshot => {
        Object.keys(snapshot.val())
          .forEach(k => this.asset.push({
            id: k,
            name: snapshot.val()[k].name
          }))
      })
      .catch(error => {
        console.log('Error - ' + error.message)
      })
    db.ref('assets/asset_data/character_model/')
      .once('value')
      .then(snapshot => {
        Object.keys(snapshot.val())
          .forEach(k => this.asset.push({
            id: k,
            name: snapshot.val()[k].name
          }))
      })
      .catch(error => {
        console.log('Error - ' + error.message)
      })
  },
  watch: {
    'numberOfSceneNodes.value' () {
      const evenProbability = parseInt((100 / this.numberOfSceneNodes.value).toFixed())

      let newProbabilities = []
      for (let i = 0; i < this.numberOfSceneNodes.value; i++) {
        newProbabilities.push(evenProbability)
      }
      this.probabilities.value = newProbabilities
    },
    currentNode () {
      this.numberOfUserNodes = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'numberOfUserNodes')
      this.numberOfSceneNodes = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'numberOfSceneNodes')
      this.probabilities = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'probabilities')
      this.selectedType = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'type').value
      this.selectedConditionType = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'conditionType').value
      this.selectedTouchType = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'touchType').value
      this.verbals = this.fetchItsUserVerbal()
      this.nonVerbals = this.fetchItsUserNonVerbal()
      this.interaction = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'interaction').value
      this.direction = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'direction').value
    },
    'numberOfUserNodes.value' () {
      if (this.selectedConditionType === 'Verbal') {
        this.updateInputFieldsNumberForVerbal()
      } else if (this.selectedConditionType === 'Non-Verbal') {
        this.updateInputFieldsNumberForNonVerbal()
      } else { // need update
        this.updateInputFieldsNumberForVerbal()
      }
    }
  },
  methods: {
    onConfirmationDialogue () {
      this.presentConfirmation = false
      this.setType(this.selectedType)
    },
    onCancelDialogue () {
      this.presentConfirmation = false
      if (this.selectedType === 'Conditional') {
        this.selectedType = 'Specific'
      } else if (this.selectedType === 'Specific') {
        this.selectedType = 'Conditional'
      }
    },
    selectType (value) {
      if (value === 'Conditional' && this.numberOfSceneNodes.value > 0) {
        this.presentConfirmation = true
      } else if (value === 'Specific' && this.numberOfUserNodes.value > 0) {
        this.presentConfirmation = true
      } else {
        this.setType(value)
      }
    },
    setType (value) {
      const selectedValue = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'type')
      selectedValue.value = value
      this.editor.signals.logicNodeTypeChanged.dispatch(value)

      if (value === 'Conditional') {
        this.editor.signals.logicNodeUserNodeCountChanged.dispatch(this.numberOfUserNodes.value)
      } else if (value === 'Specific') {
        this.editor.signals.logicNodeSceneNodeCountChanged.dispatch(this.numberOfSceneNodes.value)
      }
    },
    selectConditionType (value) {
      this.setConditionType(value)
    },
    setConditionType (value) {
      const selectedValue = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'conditionType')
      selectedValue.value = value
    },

    selectTouchType (value) {
      this.setTouchType(value)
    },
    setTouchType (value) {
      const selectedValue = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'touchType')
      selectedValue.value = value
    },

    numberOfUserNodesChanged (value) {
      // this.editor.signals.logicNodeUserNodeCountChanged.dispatch(value)
    },
    numberOfSceneNodesChanged (value) {
      this.editor.signals.logicNodeSceneNodeCountChanged.dispatch(value)
    },
    probabilityChanged (i) {
      let val = this.probabilities.value[i]
      let newAverage = Math.floor((100 - val) / (this.probabilities.value.length - 1))

      this.probabilities.value = this.probabilities.value.map((probability, index) => {
        if (index !== i) {
          probability = newAverage
        }
        return probability
      })
    },
    enableSynonymDialog () {
      // copied from user tab
      fuzz()
        .meansLike(this.keywordInput)
        .ask()
        .then(res => {
          if (res.length !== 0) {
            let wordsList = []
            for (let i = 0; i < 6; i++) {
              wordsList.push(res[i].word)
            }
            this.editor.signals.enableSynonymDialog.dispatch(wordsList)
            console.log(wordsList)
          } else {
            console.log(this.keywordInput + ' does NOT have synonyms')
          }
        })
    },
    enableSimilarityDialog () {
      this.editor.signals.enableSynonymDialog.dispatch(this.keywordInput, this.keywords)
    },
    addToLists (value) {
      this.userNodeList.push(value)
    },
    checkIfAddedInUserNodeList (value) {
      return this.userNodeList.find(node => node.id === value.id)
    },
    checkIfUserExisted (value) {
      let nodelinksAfterCurrLogic = this.diagramData.linkDataArray.filter(link => link.from === this.currentNode.data.key)
      let userNodes = []
      if (nodelinksAfterCurrLogic.length !== 0) {
        let nodesIds = nodelinksAfterCurrLogic.map(link => link.to)
        nodesIds.forEach(id => {
          this.diagramData.nodeDataArray.forEach(node => {
            if (node.key === id && node.category === 'User') {
              userNodes.push(node)
            }
          })
        })
      }
      if (this.selectedType === 'Conditional' && this.selectedConditionType === 'Verbal') {
        if (userNodes.find(node => node.selectedValues[1].value[0].id === value.id)) {
          return true
        } else {
          return false
        }
      } else if (this.selectedConditionType === 'Non-Verbal') {
        if (userNodes.find(node => node.selectedValues[2].value[0].id === value.id)) {
          return true
        } else {
          return false
        }
      } else if (this.selectedType === 'Touch' && this.selectedTouchType === '3D') {
        if (userNodes.find(node => node.selectedValues[1].value[0].id === value.id)) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    addUser () {
      if (this.userNodeList.length > 0) {
        if (this.selectedConditionType === 'Non-Verbal') {
          this.userNodeList.forEach(userNode => {
            this.addUserWithNonVerbal(userNode)
          })
        } else if (this.selectedConditionType === 'Verbal') {
          this.userNodeList.forEach(userNode => {
            this.editor.signals.addUserWithText.dispatch(userNode)
          })
        } else {
          this.userNodeList.forEach(userNode => {
            this.editor.signals.addUserWithText.dispatch(userNode)
          })
        }
      }
    },
    addUserWithNonVerbal (object) {
      if (object.visualItem) {
        switch (object.visualItem) {
          case 'age':
            object.visualItemType = 'scale'
            break
          case 'gender':
            object.visualItemType = 'selection'
            break
          default:
            object.visualItemType = 'boolean'
        }
      }
      this.editor.signals.addUserWithText.dispatch(object)
    },
    fetchItsUserVerbal () {
      let nodelinksAfterCurrLogic = this.diagramData.linkDataArray.filter(link => link.from === this.currentNode.data.key)
      if (nodelinksAfterCurrLogic.length !== 0) {
        let nodesIds = nodelinksAfterCurrLogic.map(link => link.to)
        let userNodes = []
        nodesIds.forEach(id => {
          this.diagramData.nodeDataArray.forEach(node => {
            if (node.key === id && node.category === 'User') {
              userNodes.push(node)
            }
          })
        })
        let keywords = []
        let keywordsNode = userNodes.map(node => node.selectedValues.find(value => value.key === 'keywords'))
        keywordsNode.forEach(node => {
          if (node.value !== undefined) {
            if (node.value.length !== 0) {
              node.value[0].value = _.trimStart(node.value[0].value)
              keywords.push(node.value[0])
            } else {
              let newEmptyValue = {key: 'keyword', value: ' ', id: uniqid()}
              keywords.push(newEmptyValue)
              node.value.push(newEmptyValue)
            }
          }
        })
        return keywords
      } else {
        return []
      }
    },
    fetchItsUserNonVerbal () {
      let nodelinksAfterCurrLogic = this.diagramData.linkDataArray.filter(link => link.from === this.currentNode.data.key)
      if (nodelinksAfterCurrLogic.length !== 0) {
        let nodesIds = nodelinksAfterCurrLogic.map(link => link.to)
        let userNodes = []
        nodesIds.forEach(id => {
          this.diagramData.nodeDataArray.forEach(node => {
            if (node.key === id && node.category === 'User') {
              userNodes.push(node)
            }
          })
        })
        let conditions = []
        let conditionsNode = userNodes.map(node => node.selectedValues.find(value => value.key === 'conditions'))
        conditionsNode.forEach(node => {
          if (node.value !== undefined && node.value.length !== 0) {
            conditions.push(node.value[0])
          }
        })
        return conditions
      } else {
        return []
      }
    },
    updateInputFieldsNumberForVerbal () {
      for (let i = 0; i < this.numberOfUserNodes.value; i++) {
        if (typeof this.verbals[i] !== 'undefined') {
          continue
        } else {
          this.verbals[i] = {key: 'keyword', value: '', id: uniqid()}
        }
      }
      this.decreaseNumberDecreaseBlankField()
    },
    decreaseNumberDecreaseBlankField () {
      if (this.numberOfUserNodes.value < this.verbals.length) {
        this.verbals = _.dropRight(this.verbals, this.verbals.length - this.numberOfUserNodes.value)
      }
      if (this.numberOfUserNodes.value < this.interaction.length) {
        this.interaction = _.dropRight(this.interaction, this.interaction.length - this.numberOfUserNodes.value)
      }
      if (this.numberOfUserNodes.value < this.direction.length) {
        this.direction = _.dropRight(this.direction, this.direction.length - this.numberOfUserNodes.value)
        console.log(this.direction.length)
      }
    },
    updateInputFieldsNumberForNonVerbal () {
      for (let i = 0; i < this.numberOfUserNodes.value; i++) {
        if (typeof this.nonVerbals[i] !== 'undefined') {
          continue
        } else {
          this.nonVerbals[i] = {
            type: 'Verbal',
            scaleValue: [0, 0],
            stringValue: '',
            selectionValue: '',
            booleanValue: true,
            visualItem: '',
            visualItemType: '',
            id: uniqid()
          }
        }
      }
      this.decreaseNumberDecreaseBlankFieldForNonVerbal()
    },
    decreaseNumberDecreaseBlankFieldForNonVerbal () {
      if (this.numberOfUserNodes.value < this.nonVerbals.length) {
        this.nonVerbals = _.dropRight(this.nonVerbals, this.nonVerbals.length - this.numberOfUserNodes.value)
      }
    },
    readOrAdjustNumberOfUserNodes () {
      let nodelinksAfterCurrLogic = this.diagramData.linkDataArray.filter(link => link.from === this.currentNode.data.key)
      let userNodes = []
      if (nodelinksAfterCurrLogic.length !== 0) {
        let nodesIds = nodelinksAfterCurrLogic.map(link => link.to)
        nodesIds.forEach(id => {
          this.diagramData.nodeDataArray.forEach(node => {
            if (node.key === id && node.category === 'User') {
              userNodes.push(node)
            }
          })
        })
      }
      let numberOfuserNode = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'numberOfUserNodes')
      if (userNodes.length === numberOfuserNode.value) {
        return numberOfuserNode
      } else {
        numberOfuserNode.value = userNodes.length
        return numberOfuserNode
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .flex {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/story-edit-view/logicPanel.vue